import React, {useState} from "react";

import { connect } from 'react-redux';
import { login ,logout} from "../../store/actions/auth";

import { Redirect } from 'react-router-dom';

import { TextField } from '@mui/material';
import CustomButton from '../common/button/CustomButton';
import { Spin } from 'antd';

const Login = ({ login, isAuthenticated,logout,isAdmin_global }) => {
 
  const [loading, setloading] = useState(false)
  const [loginerror, setloginerror] = useState(false)

    const [formData, setFormData] = useState({
    email: '',
    password: ''
});
const [ isAdmin, setisAdmin] = useState(isAdmin_global ? isAdmin_global : false)

const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const[success, setSuccess] = useState();
  const onSubmit = (e) => {
    login(formData?.email, formData?.password, setSuccess,setisAdmin,setloading,
      setloginerror);
};

if(!isAdmin && success )
return <Redirect to="/" /> 
if(isAdmin  && success)
return <Redirect to="/admin-tool" /> 
  return (
    <>
 <div className="container row2" style={{width:'100%',
  justifyContent:'center', textAlign:'center',
  alignItems:'center', marginLeft:'5%'
}}>
    <div    
     className='full-site'
     style={{zIndex:10}}
    >
    { 
   loading ?
   <div style={{justifyContent:'center', alignItems:'center', alignSelf:'center',
   paddingTop:'10%',minHeight:'600px'}}> 
   <Spin size="large" />
   </div>
    :
    success!=true ? 
    <><h2>LOGIN</h2>
    
    
    <div style={{ justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
            <form
            style={{backgroundColor:'#F5F5F5',
        padding:'5%', marginLeft:'10%', marginRight:'10%'}}
    >

                  <TextField 
                label="Enter Email" variant="outlined" 
                className='form-control'
                type='email'
                placeholder='Enter Email'
                onChange={e => onChange(e)}
                style={{width:'80%', backgroundColor:'white', borderRadius:5}}
                  name="email"
                     />

                  <br />

                   <TextField
                   label="Enter Password" variant="outlined" 
                        className='form-control'
                        type='password'
                        placeholder='Enter Password'
                        onChange={e => onChange(e)}
                        style={{width:'80%', backgroundColor:'white', borderRadius:5,
                        marginTop:'3%',  marginBottom:'6%'}}
                      name="password"
                      />
                  <br />

                  <div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
        <CustomButton onClick={(e)=>{onSubmit(e)}} color={'bright'} title={'LOGIN'}
      largebutton={true} style={{width:'80%',}}/></div> 
      {/* loginerror = blocked, lasttry */}
      {/* {success == false ? <p style={{ color: "red" }}>The email or password is incorrect</p> : null}
      {success ? <p style={{ color: "green" }}>Login success!</p> : null} */}
        </form>
              
              </div>
                  </>
:
   <>
<div>
</div>
</>}
    </div>
    </div>
     </>
  );
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    isAdmin_global: state.auth.isAdmin,
    email: state.auth.user?.email
});

export default connect(mapStateToProps, { login, logout })(Login);